import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseAcceptanceIntervals = async () => {
  return await request.get(
    `/FlatsGrid/intervals`,
    {},
    'При загрузке возможных интервалов для приемки произошла ошибка',
    []
  );
};

const useHouseAcceptanceIntervals = (options) =>
  useQuery(
    getQueryKeys.houseAcceptanceInterval(),
    getHouseAcceptanceIntervals,
    options
  );

export default useHouseAcceptanceIntervals;
